"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.get_transaction_challenges_to_csv = get_transaction_challenges_to_csv;
var api_1 = require("../../../api");
var store_1 = require("../../../../store");
function get_transaction_challenges_to_csv(request) {
    return __awaiter(this, void 0, void 0, function () {
        var client_token, content, response, file_id, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    console.log("get_transaction_challenges_to_csv -> request", request);
                    client_token = store_1.redux_store.getState().userState.client_token;
                    console.log("get_transaction_challenges_to_csv -> client_token", client_token);
                    content = __assign(__assign({}, request), { format: request.format || "csv", include_headers: (_a = request.include_headers) !== null && _a !== void 0 ? _a : true, fields: request.fields || [
                            "_id",
                            "challenge_transaction_id",
                            "challenge_name",
                            "challenge_start_date_time",
                            "challenge_end_date_time",
                            "user_id",
                            "user_name",
                            "branch_location",
                            "challenge_status",
                            "reward_earned",
                            "xp_points_earned",
                            "created_at",
                            "updated_at",
                        ] });
                    console.log("get_transaction_challenges_to_csv -> content", content);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, new api_1.API().apiPost({
                            baseUrl: (_b = process.env.LETS_ACHIEVE_URL) !== null && _b !== void 0 ? _b : "",
                            endpoint: "transactions/challenges/export",
                            content: content,
                            authorization: "".concat(client_token),
                        })];
                case 2:
                    response = _c.sent();
                    file_id = response;
                    console.log("get_transaction_challenges_to_csv -> file_id", file_id);
                    return [2 /*return*/, file_id];
                case 3:
                    error_1 = _c.sent();
                    console.error("get_transaction_challenges_to_csv error:", error_1);
                    throw error_1;
                case 4: return [2 /*return*/];
            }
        });
    });
}
